import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Mission from "../components/Mission";
import Vision from "../components/Vision";
const AboutPage = () => {
  return (
    <div className="min-h-screen pb-10 ">
      <div className="min-h-screen bg-opacity-70">
        <Navbar />

        {/* Hero Section */}
  
      <section className="px-6 py-20 text-center text-white bg-blue-900">
      <h1 className="text-4xl font-bold text-white md:text-6xl">
        Welcome to <span className="text-white">Harmony School</span>
      </h1>
      <p className="max-w-2xl mx-auto mt-6 text-lg text-blue-200">
        Empowering students with knowledge, discipline, and creativity. Where learning is a journey and every student shines.
      </p>
      <div className="mt-8">
        <button className="px-6 py-3 font-semibold text-white transition bg-blue-900 shadow-md shadow-white rounded-xl">
          Learn More
        </button>
      </div>
    </section>

<Mission />
<Vision />
<section className="px-4 py-20 bg-white sm:px-6 lg:px-8">
  <div className="max-w-6xl mx-auto text-center">
    <h2 className="mb-6 text-3xl font-bold text-blue-900 sm:text-4xl">Why Choose Harmony School?</h2>
    <p className="max-w-3xl mx-auto mb-10 text-lg text-gray-700">
      At Harmony School, we're committed to shaping well-rounded students equipped for future challenges. Here's what makes us different:
    </p>

    <div className="grid gap-8 text-left md:grid-cols-3">
      <div className="p-6 shadow-sm rounded-xl bg-blue-50">
        <h3 className="mb-2 text-xl font-semibold text-blue-800">Experienced Educators</h3>
        <p className="text-gray-700">
          Our passionate, qualified teachers are dedicated to academic excellence and nurturing student potential.
        </p>
      </div>
      <div className="p-6 shadow-sm rounded-xl bg-blue-50">
        <h3 className="mb-2 text-xl font-semibold text-blue-800">Modern Facilities</h3>
        <p className="text-gray-700">
          From digital classrooms to well-equipped labs, we provide a stimulating and safe learning environment.
        </p>
      </div>
      <div className="p-6 shadow-sm rounded-xl bg-blue-50">
        <h3 className="mb-2 text-xl font-semibold text-blue-800">Holistic Development</h3>
        <p className="text-gray-700">
          Beyond academics, we focus on leadership, ethics, arts, sports, and emotional intelligence.
        </p>
      </div>
    </div>
  </div>
</section>

   <Footer />
      </div>
    </div>
  );
};

export default AboutPage;
